module.exports = __webpack_public_path__ + "static/media/arrow-down-sign-to-navigate.12ad1d95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/arrow-down-sign-to-navigate.svg
// module id = 2247
// module chunks = 0